import { i18n } from 'platform-lib-app';

export default [
  {
    // 消息（总）
    path: '/info',
    name: 'info',
    component: () => import('@/view/info/infoList.vue'),
  },
  {
    // 任务
    path: '/task',
    name: 'task',
    component: () => import('@/view/info/taskList.vue'),
  },
  {
    // 通知
    path: '/notice',
    name: 'notice',
    component: () => import('@/view/info/noticeList.vue'),
  },
  {
    // 公告
    path: '/announce',
    name: 'announce',
    component: () => import('@/view/info/announceList.vue'),
  },
  {
    // 公告详情
    path: '/announce/detail',
    name: 'announceDetail',
    component: () => import('@/view/info/announceDetail.vue'),
    meta: {
      isAnnounce: true,
    },
  },
  {
    // 新闻详情
    path: '/news/detail',
    name: 'newsDetail',
    component: () => import('@/view/info/announceDetail.vue'),
  },
  {
    //我的-设置
    path: '/notice-settings',
    name: 'notice-settings',
    component: () => import('@/view/info/settings.vue'),
  }
];
